module.exports = __webpack_public_path__ + "img/img7.4d96bb6a.svg";